import React, { useEffect, useState } from 'react';
import './Modal.scss';
import Modal from 'react-modal';
import { IconClose } from '../../assets/svgs-index';

interface ModalRegisterProps {
  modalIsOpen: boolean;
  title: string;
  message?: string;
  subMessage?: string;
  confirmText?: string;
  showClose?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ModalInformation = (props: ModalRegisterProps) => {
  const [modalIsOpen, setModalIsOpen] = useState(props.modalIsOpen);
  const [title, setTitle] = useState(props.title);
  const [message, setMessage] = useState(props.message);
  const [subMessage, setSubMessage] = useState(props.subMessage);
  const [confirmText, setConfirmText] = useState(props.confirmText);
  const [showClose, setShowClose] = useState(props.showClose ?? true); 

  useEffect(() => {
    setModalIsOpen(props.modalIsOpen);
    setTitle(props.title);
    setMessage(props.message);
    setSubMessage(props.subMessage);
    setConfirmText(props.confirmText);
    setShowClose(props.showClose ?? true);
  }, [props.modalIsOpen, props.title, props.message, props.subMessage, props.confirmText, props.showClose]);

  const closeModal = () => {
    setModalIsOpen(false);
    props.onClose();
  };

  const renderCTAContainer = () => {
    return (
      <div className="cta-button-primary d-medium mt-4" role="button" onClick={props.onConfirm}>
        {confirmText}
      </div>
    );
  }

  const renderTextWithBold = (text: string): JSX.Element[] => {
    // Split text into segments with regular and bold text
    const segments = text.split(/(\*\*.*?\*\*)/).filter(Boolean);
    return segments.map((segment, index) => {
      if (/^\*\*(.*?)\*\*$/.test(segment)) {
        // Remove the bold markers and return the text in bold
        return <strong key={index}>{segment.slice(2, -2)}</strong>;
      } else {
        // Return the text as is, wrapped in a span for React key
        return <span key={index}>{segment}</span>;
      }
    });
  };

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} shouldCloseOnOverlayClick={showClose}>
      <div className="modal-content-container d-flex flex-column align-center">
        {showClose && (
          <div className="icon-close" role="button" onClick={closeModal}>
            <img src={IconClose} alt="icon-modal-close" />
          </div>
        )}
        <div className="w-100 d-column-flex align-center">
          <h2 className="m-0 p-0 text-center">{title}</h2>
          <p className="light mt-4 text-center mx-0 mx-sm-0">
            {message?.split('\n').map((line, index) => (  // Trocar \n na string por <br/>
              <React.Fragment key={index}>
                {renderTextWithBold(line)}
                {index !== message.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
          <p className="light text-center mt-1 mx-3 mx-sm-6">
            {subMessage?.split('\n').map((line, index) => (  // Trocar \n na string por <br/>
              <React.Fragment key={index}>
                {renderTextWithBold(line)}
                {index !== subMessage.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
            
          </p>
          {renderCTAContainer()}
        </div>
      </div>
    </Modal>
  );

}

export default ModalInformation;